module.exports = __webpack_public_path__ + "static/media/next-arrow.6e50c226.svg";